export const NO_SEARCH_RESULTS_PLACEHOLDER = 'No results found';
export const EMPTY_MESSAGES_LIST_PLACEHOLDER =
  'Every great conversation starts with a single message. Why not send one now?';
